import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { QuotaSelect as LocalQuotaSelect } from '../../components/QuotaSelect'

export const QuotaSelect = connect(
  LocalQuotaSelect,
  mapReadPretty(LocalQuotaSelect, {
    disabled: true
  })
)
